import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'ui';

import s from './InputLabel.module.scss';

const cx = cn.bind(s);

const InputLabel = ({
  text,
  variant,
  error,
  showErrorMessage,
  children,
  ...attrs
}) => {
  const isBrainableVariant = variant === 'brainable';
  const isBrainableSaveVariant = variant === 'brainableSave';
  const labelClassName = cx('label', {
    error,
    brainable: isBrainableVariant,
    brainableSaveLabel: isBrainableSaveVariant,
  });
  return (
    <div {...attrs}>
      <label className={labelClassName} >
        <span className={cx('text', {
          brainable: isBrainableVariant,
          brainableSaveText: isBrainableSaveVariant,
        })}>{text}</span>
        {children}
      </label>
      {error && showErrorMessage && <ErrorMessage className={cx('errorMessage')} text={error} />}
    </div>
  );
};

InputLabel.propTypes = {
  error: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'brainable', 'brainableSave']),
  showErrorMessage: PropTypes.bool,
  text: PropTypes.string,
};

InputLabel.defaultProps = {
  error: '',
  className: '',
  variant: 'default',
  showErrorMessage: true,
  text: '',
};

export default InputLabel;
